// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__klc5d","file":"styles_file__3KDlz"};